/* eslint-disable */
export default {
  noRecords: 'No se encontraron registros recientes.',
  inBound: 'Entrante',
  outBound: 'Saliente',
  missed: 'Llamada perdida',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
